import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles } from "@material-ui/core/styles";
import { usePages } from "../../pagesContext";
import { addRegisteredStepper } from "./stepperDescriptions";
import { usePageState } from "../../PageContext";
import { Grid, Typography } from "@material-ui/core";
import { FormattedMessage, FormattedNumber } from "react-intl";
const useStepperTextStepperStyles = makeStyles((theme) => ({
    textContent: {
        fontSize: 18,
        color: theme.palette.accent1?.main
    }
}));
addRegisteredStepper({
    name: "TextStepper",
    displayName: "TextStepper"
});
export const TextStepper = (props) => {
    const pages = usePages();
    const { step } = usePageState();
    const textStepperClasses = useStepperTextStepperStyles();
    const hideStepper = pages[step].hideStepper ?? false;
    if (hideStepper)
        return null;
    var count = -1;
    const displayIndexArr = pages.map(p => {
        if (p.displayInStepper) {
            count += 1;
            return count;
        }
        return -1;
    });
    const getDisplayNum = (step) => {
        if (step === 0 && displayIndexArr[step] === -1) {
            return -1;
        }
        return displayIndexArr[step] === -1
            ? getDisplayNum(step - 1)
            : displayIndexArr[step] + 1;
    };
    const activeStep = getDisplayNum(step);
    return activeStep > -1 ? (_jsx(Grid, { container: true, justifyContent: "center", children: _jsxs(Typography, { className: textStepperClasses.textContent, children: [_jsx(FormattedMessage, { id: "dploy.text-stepper.part", defaultMessage: "Part " }), _jsx(FormattedNumber, { value: activeStep }), _jsx(FormattedMessage, { id: "dploy.text-stepper.of", defaultMessage: " of " }), _jsx(FormattedNumber, { value: count + 1 })] }) })) : null;
};
//# sourceMappingURL=TextStepper.js.map